import {
  Box,
  Button,
  Grid,
  Modal,
  ModalBody,
  ModalClose,
  ModalFooter,
} from "@flexisaf/flexibull2";
import styled from "styled-components";
import Theme from "../../theme";

const I = styled.i`
  font-size: 36px;
  color: #ea2a8a;
  text-align: left;
  align-self: left;
`;

const DeleteModal = ({
  onClose,
  isOpen,
  title,
  description,
  isLoading,
  onDelete,
}) => {
  return (
    <Modal onClose={onClose} open={isOpen}>
      <ModalBody width="35vw">
        <ModalClose onClick={onClose}>&times;</ModalClose>
        <Box pad="5px 30px">
          <h2>{title}</h2>
        </Box>
        <Box pad="0 30px 10px">
          <Grid default="15% 70% 10%" alignItems="center">
            <I className="saf-danger"></I>
            <p>{description}</p>
            <Box />
          </Grid>
        </Box>
        <ModalFooter>
          <Box pad="20px" align="right">
            <Button
              pale
              onClick={onClose}
              color="rgba(0,0,0,0)"
              fontColor={Theme.PrimaryGrey}
            >
              Cancel
            </Button>
            <Button
              progress={isLoading}
              color={Theme.PrimaryRed}
              onClick={() => onDelete()}
            >
              Yes, Delete
            </Button>
          </Box>
        </ModalFooter>
      </ModalBody>
    </Modal>
  );
};

export default DeleteModal;
